<template>
  <div id="newAddAnnouncement">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item>渠道政策</el-breadcrumb-item>
        <el-breadcrumb-item :to="{ path: '/Announcements/newAnnouncement' }">通知公告</el-breadcrumb-item>
        <el-breadcrumb-item>新增公告</el-breadcrumb-item>
      </el-breadcrumb>
    <div class="page">
      <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm">
        <el-form-item label="公告主题" prop="notice_title">
          <el-input placeholder="请输入内容" v-model="ruleForm.notice_title" size="small" style="width: 425px;" clearable></el-input>
        </el-form-item>
        <el-form-item label="公告类型" prop="notice_type">
          <el-select v-model="ruleForm.notice_type" placeholder="请选择公告类型" size="small" style="width: 425px;">
            <!-- <el-option label="全部" value=""></el-option> -->
            <el-option :label="item.dictName" :value="item.id" v-for="item in listoptions"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="发布方式" prop="notice_send_type">
          <el-radio :label="2" v-model="ruleForm.notice_send_type">所有人</el-radio>
          <el-radio :label="3" v-model="ruleForm.notice_send_type">按店铺发布</el-radio>
          <el-radio :label="0" v-model="ruleForm.notice_send_type">按部门发布</el-radio>
          <el-radio :label="1" v-model="ruleForm.notice_send_type">按品类发布</el-radio>
        </el-form-item>
        <el-form-item label="店铺" v-if="ruleForm.notice_send_type == 3" :required="true">
          <div style="display: flex;">
            <div class="addFont" @click="setShopShow = true" style="margin-top: 5px;">
              <i class="el-icon-plus"></i>
              选择店铺
            </div>
            <div style="color: #ccc;margin-left: 8px;">
              已选 {{valueData.length}} 个店铺
            </div>
          </div>
          <div style="width: 715px;height: 130px;background: #f4f4f5;margin-top: 20px;overflow: auto;">
            <div class="shopNameClass" v-for="item in valueData">
              {{item.shopname}}
            </div>
          </div>
        </el-form-item>
        <el-form-item label="接收部门" prop="receive_name" v-show="ruleForm.notice_send_type == 0">
          <el-select v-model="ruleForm.receive_name" multiple placeholder="请选择" size="small" style="width: 425px;">
            <el-option style="height: 500px;background-color: white;" value=''>
              <el-tree :data="options" :props="defaultProps" @check-change="serviceSector" show-checkbox check-strictly></el-tree>
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="品牌品类" prop="receive_departids" v-show="ruleForm.notice_send_type == 1">
          <el-select v-model="ruleForm.receive_departids" placeholder="请选择" size="small" multiple style="width: 425px;">
            <el-option
              v-for="item in ProductClassify"
              :key="item.id"
              :label="item.productClassifyName"
              :value="item.id"
              >
            </el-option>
          </el-select>
        </el-form-item>
        <!-- <div style="display: flex;">
          <div class="titleLable">
            <span style="color: #F56C6C;">
              *
            </span>
            公告内容
          </div>
          <div id="editor" class="editor" style="width: 717px;"></div>
        </div> -->
        <el-form-item label="公告内容" prop="formArticle" style="position: relative;">
          <div id="editor" class="editor" style="width: 717px;height: 351px;"></div>
          <div style="background-color: white;position: absolute;top: 352px;width: 90px;height: 18px;z-index: 900;color: white;" v-show="wildWest">1</div>
        </el-form-item>
        <el-form-item label="上传附件">
          <el-upload class="upload-demo" :action="UploadUrl()" :on-success="handleChange" :on-remove="handleRemove"	:data="uploadType" style="width: 517px;" :before-upload="beforeAvatarUpload" accept=".rar,.zip,.doc,.docx,.xls,.xlsx,.ppt,.pptx,.pdf,.jpg,.png">
            <el-row>
              <el-col :span="24"  style="display: inline-flex;">
                <el-button size="small" plain icon="el-icon-upload2">点击上传</el-button>
                <div style="background-color: #f7f7f7;padding-left: 10px;margin-left: 10px;width: 600px;">支持扩展名：.rar .zip .doc .docx .xls .xlsx .ppt .pptx .pdf .jpg .png    文件大小100MB以内。</div>
              </el-col>
            </el-row>
          </el-upload>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="submitForm('ruleForm')" size="small" :loading="loadingUpDe">确 定</el-button>
          <el-button @click="resetForm" size="small" type="TheCustom" style="margin-left: 10px;">取 消</el-button>
        </el-form-item>
      </el-form>
    </div>
    <el-dialog
      title='选择店铺'
      :visible.sync="setShopShow"
      :close-on-click-modal="false"
      width="960px"
      id="activityDeclarationdialog">
      <el-transfer
        filterable
        :filter-method="filterMethod"
        filter-placeholder="请输入店铺名称"
        v-model="valueIndex"
        :button-texts="['到左边', '到右边']"
        :titles="['不通知店铺', '通知店铺']"
        :data="transferData"
        @change="leftChange"
        >
      </el-transfer>
      <span slot="footer">
        <el-button size="small" type="TheCustom" @click="setShopShow = false">关 闭</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
  import aes from "../../libs/aes";
  import E from 'wangeditor';
  export default {
    data() {
      return {
        uploadType: {
          tong: 'newAddAnnouncement'
        },
        ruleForm: {
          notice_title: '',
          notice_send_type: 2,
          receive_name: [],
          notice_type: '',
          notice_content: '',
          desc: '',
          receive_departids: [],
        },
        wildWest: false,
        loadingUpDe: false,
        type: [],
        dataId: [],
        ProductClassify: [],
        listoptions: [],
        defaultProps: {
          children: 'subSysDepartment',
          label: 'departName',
        },
        uploadData: {
         classifyid: this.$route.query.e,
        },
        options: [],
        departids: '',
        attach_urls: [],
        rules: {
          notice_title: [
            { required: true, message: '请输入公告主题', trigger: 'blur' }
          ],
          notice_send_type: [
            { required: true, message: '请选择公告类型', trigger: 'blur' }
          ],
          receive_name: [
            { required: true, message: '请选择接收部门', trigger: 'change' }
          ],
          notice_type: [
            { required: true, message: '请选择公告类型', trigger: 'change' }
          ],
          receive_departids: [
            { required: true, message: '请选择品牌品类', trigger: 'change' }
          ],
          formArticle: [
            { required: true, message: '请填写公告内容', trigger: 'change' }
          ],
        },
        setShopShow: false,
        filterMethod(query, item) {
          return item.label.indexOf(query) > -1;
        },
        contentArr: [],
        valueIndex: [],
        valueData: [],
        transferData: [],
      }
    },
    created(){
  	},

    mounted() {
      this.announcementType();
      this.getAllUserTreeByDepartId();
      this.wangEditor();
      this.ProductClassifyList();
      this.announcementYype();
      this.getPageByBmcs()
    },
    methods: {
      generateData() {
        this.transferData = [];
        this.contentArr.forEach((city, index) => {
          this.transferData.push({
            label: city.shopname,
            key: index,
          });
        });
        return this.transferData;
      },
      getPageByBmcs(){
        let params = {
          pageSize: 5000,
          pageNo: 1,
        }
        fetch({url: "hcm/hcmShop/getPageByBmc", method: "get", params}).then((res)=>{
          this.contentArr = []
          this.valueIndex = []
          if (res.data.content && res.data.content.length != 0) {
            for (let a in res.data.content) {
              this.contentArr.push({
                shopname: res.data.content[a].platformname + ' ' +res.data.content[a].shopname,
                campaignstatus: res.data.content[a].campaignstatus,
                id: res.data.content[a].id
              })
            }
            this.generateData()
          }
        })
      },
      leftChange(left,right) {
        let idsArr = []
        if (left instanceof Array) {
          this.valueIndex = left
        } else {
          this.valueIndex = right
        }
        if (this.valueIndex && this.valueIndex.length != 0) {
          for (let b in this.valueIndex) {
            idsArr.push(this.contentArr[this.valueIndex[b]].id)
          }
        }
        this.valueData = []
        for (let a in this.contentArr) {
          for (let e in idsArr) {
            if (this.contentArr[a].id == idsArr[e]) {
              this.valueData.push(this.contentArr[a])
            }
          }
        }
      },
      announcementYype() {
        let params={
          dictcode: 'notice_type',
        }
        fetch({
          url: "hcm/sys/GetList",
          method: "get",
          params: params,
          noFormat: true,
          responseType: "text"
        }).then(result => {
          let res = JSON.parse(result);
          let {data}=res
          if(res.status == '10000'){
            this.listoptions = data;
          }
        }).catch(err => {
          this.$message.error('接口异常');
        });
      },
      wangEditor() {
        var editor = new E('#editor')
          editor.customConfig.onchange = (html) => {
            this.formArticle = html
          }
          editor.customConfig.uploadImgServer = '<%=path%>/Img/upload'; //上传URL
          editor.customConfig.uploadImgMaxSize = 3 * 1024 * 1024;
          editor.customConfig.uploadImgMaxLength = 5;
          editor.customConfig.uploadFileName = 'myFileName';
          editor.customConfig.uploadImgHooks = {
          customInsert: function (insertImg, result, editor) {
            // 图片上传并返回结果，自定义插入图片的事件（而不是编辑器自动插入图片！！！）
            // insertImg 是插入图片的函数，editor 是编辑器对象，result 是服务器端返回的结果

            // 举例：假如上传图片成功后，服务器端返回的是 {url:'....'} 这种格式，即可这样插入图片：
            var url =result.data;
            insertImg(url);

            // result 必须是一个 JSON 格式字符串！！！否则报错
          }
        }
        editor.create();
      },
      beforeAvatarUpload(file) {
      this.loadingUpDe = true
       const isLt2M = file.size / 1024 / 1024 < 100;
       if (!isLt2M) {
         this.$message.error('上传文件大小不能超过 100MB!');
       }
       return isLt2M;
      },
      handleRemove(file, fileList) {
        for (var i in this.attach_urls) {
          if (this.attach_urls[i].name == file.name && this.attach_urls[i].url == file.response.data.data) {
            this.attach_urls.splice(i,1)
          }
        }
      },
      handleChange(file, fileList) {
        this.loadingUpDe = false
        if (file.data.code == 2000) {
          this.$message.error(file.data.msg);
        }
        if (file.data.code == 0) {
          this.$message({
            message: file.data.msg,
            type: 'success'
          });
        }
        this.attach_urls.push({
          name:fileList.name,
          url:fileList.response.data.data
        })
      },
      UploadUrl() {
        return "hcm/hcmWorkOrder/headUpload";
      },
      getAllUserTreeByDepartId() {
        let params={
          id: '0',
        }
        fetch({
          url: "hcm/department/fuByIds",
          method: "get",
          params: params,
          noFormat: true,
          responseType: "text"
        }).then(result => {
          let res = JSON.parse(result);
          let {data}=res
          if(res.status == '10000'){
            this.options = data;
          }
        }).catch(err => {
          this.$message.error('接口异常');
        });
      },
      ProductClassifyList() {
        fetch({
          url: "hcm/ProductClassify/list",
          method: "get",
          // params: params,
          noFormat: true,
          responseType: "text"
        }).then(result => {
          let res = JSON.parse(result);
          let {data}=res
          if(res.status == '10000'){
            this.ProductClassify = data;
          }
        }).catch(err => {
          this.$message.error('接口异常');
        });
      },
      submitForm(formName) {
        console.log(this.valueData)
        this.$refs[formName].validate((valid) => {
          if (this.ruleForm.notice_send_type == 3 && this.valueData.length == 0) {
            this.$message({
              message: '请选择店铺',
              type: 'warning'
            });
            return
          }
          let receive_shopids = []
          for (let a in this.valueData) {
            receive_shopids.push(this.valueData[a].id)
          }

          let personNameBytes = this.formArticle.replace(/[^\x00-\xff]/g, '01').length
          if (personNameBytes > 16777215) {
            this.$message({
              message: '文件过大',
              type: 'error'
            });
            return;
          }
          if (this.formArticle != undefined) {
            this.wildWest = true
          }
          if (valid == false && this.ruleForm.notice_send_type == 1 && this.ruleForm.receive_departids && this.ruleForm.notice_title && this.ruleForm.notice_type && this.formArticle
            || valid == false && this.ruleForm.notice_send_type == 0 && this.ruleForm.receive_departids && this.ruleForm.notice_title && this.ruleForm.notice_type && this.formArticle
            || valid == false && this.ruleForm.notice_send_type == 2 && this.ruleForm.notice_title && this.ruleForm.notice_type && this.formArticle
            || valid == false && this.ruleForm.notice_send_type == 3 && receive_shopids
            || valid) {
            this.loadingUpDe = true
            let params={
              notice_title: this.ruleForm.notice_title,
              notice_type: this.ruleForm.notice_type,
              notice_content: this.formArticle,
              notice_send_type: this.ruleForm.notice_send_type,
              receive_shopids: receive_shopids.join(',')
            }
            if (this.ruleForm.notice_send_type == 0) {
              params.receive_departids = this.ruleForm.receive_departids
            } else {
              params.receive_classifyids = this.ruleForm.receive_departids.join(',')
            }
            if (this.attach_urls) {
              params.attach_urls = JSON.stringify(this.attach_urls)
            }

            fetch({
              url: "hcm/notice/Create",
              method: "post",
              data: params,
              noFormat: true,
              responseType: "text",
              timeout: 60 * 1000 * 5
            }).then(result => {
              let res = JSON.parse(result);
              let {data}=res
              if(res.status == '10000'){
                this.$router.push({
                  path: '/Announcements/newAnnouncement'
                })
                this.loadingUpDe = false
              } else {
                this.$message({
                  message: res.message,
                  type: 'error'
                });
                this.loadingUpDe = false
              }
            }).catch(err => {
              this.$message.error('接口异常');
            });
          } else {
            return false;
          }
        });
      },
      resetForm() {
        this.$router.push({
          path: '/Announcements/newAnnouncement'
        })
      },
      serviceSector(data,node) {
        console.log(data)
        console.log(this.ruleForm.receive_name + '111')

        if (node == true) {
          this.dataId.push(data.id)
          this.ruleForm.receive_name.push(data.departName)
        } else {
          for (var i = 0; i < this.dataId.length; i++) {
            if (this.dataId[i] == data.id) {
              this.dataId.splice(i,1)
            }
          }
          for (var i = 0; i < this.ruleForm.receive_name.length; i++) {
            if (this.ruleForm.receive_name[i] == data.departName) {
              this.ruleForm.receive_name.splice(i,1)
            }
          }
        }
        this.ruleForm.receive_departids = this.dataId.join(',');
        console.log(this.ruleForm.receive_departids)
      },
      theQuery() {
        let params={
          pageNo: this.pageNo,
          pageSize: this.pageSize,
          start_time: this.$options.filters['fullTime'] (this.searchformDate[0]),
          end_time: this.$options.filters['fullTime'] (this.searchformDate[1]),
        }
        if (this.notice_type) {
          params.params = this.notice_type
        }
        if (this.notice_title) {
          params.params = this.notice_title
        }
        if (this.user_name) {
          params.params = this.user_name
        }
        fetch({
          url: "hcm/notice/Getlist",
          method: "get",
          params: params,
          noFormat: true,
          responseType: "text"
        }).then(result => {
          let res = JSON.parse(result);
          let {data}=res
          if(res.status == '10000'){
            this.tableData = data.content;
            this.totalNum = data.totalElements;
          } else if (res.status == '10400') {

          }
        }).catch(err => {
          this.$message.error('接口异常');
        });
      },
      announcementType() {
        let params={
          dictcode: 'notice_type',
        }
        fetch({
          url: "hcm/sys/GetList",
          method: "get",
          params: params,
          noFormat: true,
          responseType: "text"
        }).then(result => {
          let res = JSON.parse(result);
          let {data}=res
          if(res.status == '10000'){
            this.typeData = data;
          }
        }).catch(err => {
          this.$message.error('接口异常');
        });
      },

    }
  }
</script>
<style scoped lang="scss">
  .shopNameClass {
    border: 1px solid #e8ebec;
    text-align: center;
    font-size: 12px;
    float: left;
    background: white;
    margin: 10px 0 10px 10px;
    padding: 0 10px 0 10px;
    cursor: pointer;
  }
  .addFont {
    color: #108cee;
    font-weight: bold;
    text-align: center;
    border: 1px dashed #e8ebec;
    height: 30px;
    width: 425px;
    line-height: 30px;
    cursor: pointer;
  }
  .addFont:hover {
    border: 1px dashed #108cee;
  }
  .header {
    width: 100%;
    height: 40px;
    background-color: white;
  }
  .page {
    padding: 20px;
    margin: 20px;
    background-color: white;
  }
  .headerSize {
    line-height: 40px;
    text-align: right;
  }
  .block {
    text-align: right;
    margin-top: 20px;
  }
  .el-button--TheCustom {
    color: #666;
    border-color: #D9D9D9;
    background-color: #fff;
  }
  .el-button--TheCustom:hover  {
    color: #666;
    border-color: #ded2b8;
    background-color: #faf9f5;
  }

</style>
<style lang="scss">
#newAddAnnouncement {
  .el-transfer {
    font-size: 14px;
    height: 500px !important;
  }
  .el-transfer-panel {
    width: 324px !important;
    height: 500px !important;
  }
  .el-transfer-panel__list.is-filterable {
    height: 396px !important;
  }
  .el-table th {
    background-color: #f3f7ff !important;
  }
  .el-radio__input.is-checked .el-radio__inner {
    border-color: #bda57e;
    background: #bda57e;
  }
  .titleLable {
    width: 100px;
    margin-bottom: 22px;
    text-align: right;
    vertical-align: middle;
    float: left;
    font-size: 14px;
    color: #606266;
    line-height: 40px;
    padding: 0 12px 0 0;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
  }
  .el-radio__input.is-checked+.el-radio__label {
    color: #666;
  }
  .editor {
    position: relative;
    z-index: 0;
    margin: 0;
  }
  #dialog {
    .el-dialog__header {
      padding: 20px 20px 10px;
      border-bottom: 1px solid #d9d9d9;
    }
  }
  .el-button+.el-button {
    margin-left: 1px;
  }
  .el-button--primary {
    color: #FFF;
    background-color: #bda571;
    border-color: #bda571;
  }
  .el-button--primary:hover {
    color: #FFF;
    background-color: #c0ae8a;
    border-color: #c0ae8a;
  }

  .w-e-toolbar .w-e-menu:nth-child(15) {
    display: none;
  }

  .w-e-menu{
    z-index: 2 !important;
  }

  .w-e-text-container{
    z-index: 1 !important;
  }

}
</style>
